module.exports = __webpack_public_path__ + "media/images/shop-dashboard-staff-online-training-6715118cea66465a4edad8a02026a440.png";